export default [
  {
    name: 'Dashboard',
    path: '/dashboard',
    component: () => import('./View.vue'),
  },
];
